module.exports = __webpack_public_path__ + "static/media/step-1.25afeb68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/how-it-works/stepper-how-it-works/step-1.png
// module id = 2210
// module chunks = 0